// extracted by mini-css-extract-plugin
export var screen1 = "style-module--screen1--5774f";
export var subtitle = "style-module--subtitle--62aed";
export var title = "style-module--title--99137";